export default "__VITE_ASSET__253f3964__"